import { cva } from 'class-variance-authority'

/**
 * Shared by the filter pills and the Filter button so they stay the same height —
 * Pill's own sizes are shorter than Button's.
 */
export const filterControlStyles = cva(`
  text-sm
  px-3
  py-2
`)
